import PageHero from "../../components/PageHero/PageHero";


import {images} from "../../constants"

import PortfolioShowcase from "../../components/PortfolioShow/PortfolioShowCase";
import { ExperienceSection, Footer, InfiniteMarquee } from "../../container";
import ContentImageSection from "../../components/ContentImageSection/ContentImageSection";
const Interior = () => {
  return <>
    <PageHero title="Interior Design Portfolio"  bgImage={images.backgroud_img}/>
    <ContentImageSection
  title="Precision Interior Design Support, Tailored for You"
  description="
    Gomal Design Studio is your strategic partner for interior design outsourcing. Our approach combines materiality, light, and layout to create environments that are not only beautiful but also deeply functional. We create stunning 3D visualizations and hyperrealistic renderings that communicate design intent with clarity and emotion. Perfect for presentations, marketing, and making confident decisions.
  "
  highlightWords={["Archilance LLC", "Revit drafting"]}
  image={images.interior_portfolio}
/>
    <div style={{ width: "80%", margin: "3rem auto" }}>
      <hr style={{ border: "none", height: "1px", backgroundColor: "#ddd" }} />
    </div>
    <PortfolioShowcase page="interior" />
    <InfiniteMarquee/>
    <ExperienceSection/>
    <Footer/>
  </>;
};

export default Interior;
